import { generatePath, useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import moment from 'moment';
import {
  Button, Card, Form, Modal, Radio,
} from 'antd';
import { faPrint } from '@fortawesome/pro-light-svg-icons';
import { getPaciente } from '../../../state/actions/creators/pacientes.actioncreator';
import { getPrescriptores } from '../../../state/actions/creators/fichaOptometrica.actioncreator';
import {
  getDatosFichaContactologica,
  getDatosUltimaOptometria, guardarDatosFichaContactologica,
} from '../../../state/actions/creators/fichaContactologica.actioncreator';
import Page from '../../shared/components/layout/Page.layout';
import { Box, Flex, Text } from '../../shared/components';
import LoadingWorkspaceSkeleton from '../../encargos/components/dataDisplay/LoadingWorkspaceSkeleton.datadisplay';
import ActionsHeader, { NAVIGATION_ANCHOR } from '../../shared/containers/ActionsHeader';
import UsuariosDrawer from '../../app/components/Usuarios.drawer';
import { descargarInforme } from '../../../state/actions/creators/informes.actioncreator';
import { ROUTE_PACIENTES_CONTACTOLOGY_EDIT } from '../../../routes.constants';
import { FichaContactologicaFormHeader } from './fichaContactologica.crear.form.header';
import { FichaContactologicaFormGraduacionAsociada } from './fichaContactologica.crear.form.graduacionAsociada';
import { FichaContactologicaFormPrescripcion } from './fichaContactologica.crear.form.prescripcion';
import { FichaContactologicaFormLimpieza } from './fichaContactologica.crear.form.limpieza';
import { FichaContactologicaFormOtros } from './fichaContactologica.crear.form.otros';
import ShowIf from '../../shared/components/dataDisplay/ShowIf';
import { useScrollToError } from '../../../hooks/useScrollToError';

export function FichaContactologicaFormulario({
  watch,
  create,
  form,
}) {
  const history = useHistory();
  const params = useParams();
  const dispatch = useDispatch();
  const { pacienteId, codigo, tiendaGraduacion } = params;
  const tiendaId = useSelector(state => state.auth.user.user_info.tienda_id);
  const tiendas = useSelector(state => state.core.tiendas);
  const usuarios = useSelector(state => state.fichaOptometricaWorkspace.usuarios);
  const datosGraduacionOriginal = useSelector(state => state.fichaContactologicaWorkspace.fichaContactologica);
  const prescriptores = useSelector(state => state.fichaOptometricaWorkspace.prescriptores);
  const paciente = useSelector(state => state.pacientesWorkspace.pacienteSelected);
  const idAttended = useSelector(state => state.auth.user.user_info.usuario_id);
  const nameAttended = useSelector(state => state.auth.user.user_info.usuario);
  const nextGrad = useSelector(state => state.auth.permisos.configuracion.prox_gradcontac);
  const fecha_prox = moment().add(nextGrad, 'days');
  const [drawerAttended, setDrawerAttended] = useState(false);
  const [drawerPrescriber, setDrawerPrescriber] = useState(false);
  const [datosGraduacion, setDatosGraduacion] = useState(datosGraduacionOriginal);
  const [error, setError] = useState(false);

  const {
    getFieldDecorator, setFieldsValue, validateFields, getFieldsError,
  } = form;
  const doScroll = useScrollToError({ overwriteChangeDetection: true, errors: getFieldsError() });
  const sagas = useSelector(state => state.sagas);
  const guardandoContactologia = sagas.GUARDAR_GRADUACION_CONTACTOLOGICA?.running;
  const setValue = (object, objectForm = undefined) => {
    setFieldsValue(objectForm || object);
    setDatosGraduacion({ ...datosGraduacion, ...object });
  };
  const onHandleError = (error)=>{
    setError(error);
  }
  useEffect(() => {
    setDatosGraduacion(datosGraduacionOriginal);

    if (create) {
      setValue({ paciente_id: paciente.id, tienda_id: tiendaId, atendido_por_id: idAttended, atendido_por_nombre: nameAttended, fecha_proxima_graduacion: fecha_prox.format('DD/MM/YYYY hh:mm:ss') }, {});
    }
  }, [datosGraduacionOriginal]);

  useEffect(() => {
    // setModalVisible(true);
  }, []);

  let titleId = 'navigation.contactologia';
  if (!watch) titleId = create ? 'navigation.nueva_contactologia' : 'navigation.editarContactologia';
  let traduccionAccionFicha = 'ficha_contactologica.mostrar_graduacion';
  if (create) {
    traduccionAccionFicha = 'ficha_contactologica.nueva_graduacion';
  } else if (!watch) {
    traduccionAccionFicha = 'ficha_contactologica.editar_graduacion';
  }
  const selectPrint = (informeId, plantillaId, parametros) => {
    dispatch(descargarInforme({ informeId, plantillaId, parametros }));
  };
  const headerData = [
    {
      translationId: 'pacientes.client_file.edit',
      text: 'Editar',
      onClick: () => history.push(generatePath(ROUTE_PACIENTES_CONTACTOLOGY_EDIT, { pacienteId: paciente.id, codigo: datosGraduacion.codigo, tiendaGraduacion })),
    },
    {
      icon: faPrint,
      position: 'right',
      onClick: () => {},
      children: [
        {
          translationId: 'pacientes.activity.prescription',
          key: 'contactology_prescription',
          text: 'Receta',
          onClick: () => {
            selectPrint(9, 39, { tienda_graduacion_id: datosGraduacion.tienda_id, graduacion_id: datosGraduacion.codigo, tienda_id: paciente.tienda_id });
          },
        },
        {
          translationId: 'pacientes.activity.history',
          key: 'contactology_history',
          text: 'Receta',
          onClick: () => {
            selectPrint(143, -1, { tienda_id: tiendaId, paciente_id: paciente.id, tienda_paciente_id: paciente.tienda_id });
          },
        },
      ],
    },
  ];

  return (
    <>

      {watch && <ActionsHeader anchor={NAVIGATION_ANCHOR} hide sticky data={headerData} /> }
      <Card
        bodyStyle={{ padding: '16px' }}
        headStyle={{ padding: '0 16px' }}
        title={(
          <Flex alignItems="center" justifyContent="space-between">
            <Text fontFamily="Open Sans" color="#595959" fontWeight="600" fontSize="19px" translationId={traduccionAccionFicha} />
          </Flex>
        )}
      >
        <Form onSubmit={(e) => {
          e.preventDefault();
          validateFields((err, values) => {
            if (!err && !error) {
              const copiaDatosGraduacion = { ...datosGraduacion };
              if (datosGraduacion.prescripcion && datosGraduacion.prescripcion.ojo_izquierdo) {
                if (datosGraduacion.prescripcion.ojo_izquierdo.ojo_dominante === 'Ninguno') {
                  copiaDatosGraduacion.prescripcion.ojo_izquierdo.ojo_dominante = null;
                }
              }
              if (datosGraduacion.prescripcion && datosGraduacion.prescripcion.ojo_derecho) {
                if (datosGraduacion.prescripcion.ojo_derecho.ojo_dominante === 'Ninguno') {
                  copiaDatosGraduacion.prescripcion.ojo_derecho.ojo_dominante = null;
                }
              }
              dispatch(guardarDatosFichaContactologica(copiaDatosGraduacion));
            } else {
              doScroll();
            }
          });
        }}
        >
          <UsuariosDrawer
            visible={drawerAttended}
            onClose={() => {
              setDrawerAttended(false);
              setDrawerPrescriber(false);
            }}
            usuarios={usuarios}
            onSeleccionado={(user) => {
              setValue({ atendido_por_nombre: user.nombreCompleto, atendido_por_id: user.id }, { atendido_por: user.nombreCompleto });
              setDrawerAttended(false);
              setDrawerPrescriber(false);
            }}
          />
          <UsuariosDrawer
            title="Prescriptores"
            visible={drawerPrescriber}
            onClose={() => {
              setDrawerAttended(false);
              setDrawerPrescriber(false);
            }}
            usuarios={prescriptores}
            onSeleccionado={(user) => {
              setValue({ prescriptor_nombre: user.nombreCompleto, prescriptor_id: user.id }, { prescriptor: user.nombreCompleto });
              setDrawerAttended(false);
              setDrawerPrescriber(false);
            }}
          />

          <Box>
            <FichaContactologicaFormHeader create={create} watch={watch} form={form} onSetValue={setValue} setDrawerAttended={setDrawerAttended} setDrawerPrescriber={setDrawerPrescriber} datosGraduacion={datosGraduacion} />
            {datosGraduacion.graduacion_optometrica_asociada && (
            <Flex mt="16px" style={{ flexWrap: 'wrap' }}>
              <Flex flexDirection="column" flex="1">
                <FichaContactologicaFormGraduacionAsociada create={create} watch={watch} form={form} onSetValue={setValue} datosGraduacion={datosGraduacion} />
              </Flex>
            </Flex>
            )}
            <Flex mt="16px" style={{ flexWrap: 'wrap' }}>
              <FichaContactologicaFormPrescripcion create={create} watch={watch} form={form} onSetValue={setValue} datosGraduacion={datosGraduacion} onError={onHandleError} />
            </Flex>
            <Flex mt="16px" style={{ flexWrap: 'wrap' }}>
              <FichaContactologicaFormLimpieza create={create} watch={watch} form={form} onSetValue={setValue} datosGraduacion={datosGraduacion} />
            </Flex>
            <FichaContactologicaFormOtros create={create} watch={watch} form={form} onSetValue={setValue} datosGraduacion={datosGraduacion} />
          </Box>
          <ShowIf condition={!watch}>
            <Flex mt="16px" justifyContent="flex-end" alignItems="center">
              <Button size="large" onClick={() => history.goBack()}>
                <Text translationId="generico.cancelar" />
              </Button>
              <Button loading={guardandoContactologia} htmlType="submit" type="primary" size="large" style={{ marginLeft: '8px' }}>
                <Text translationId="ficha_contactologica.guardar_contactologia" />
              </Button>
            </Flex>
          </ShowIf>
        </Form>
      </Card>
    </>
  );
}
